export default __webpack_public_path__ + "static/media/logo.5b6b32a0.png";